import { InputBar_Input } from 'emerald-ui';
import { gray0, gray1, gray3 } from 'emerald-ui/dist/globals/colors';
import { font } from 'emerald-ui/dist/globals/fonts';
import styled from 'styled-components';
import { SearchBar } from '../SearchBar';

export const PageHeader_Root = styled.div`
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    background: ${gray0};
    padding: 25px;
`;

export const PageHeader_Left = styled.div`
    img {
        height: ${(props) => props.forwarder === 'Navegate' && '50px'};
        max-height: ${(props) => props.forwarder === 'Centrade' && '50px'};
    }
`;

export const PageHeader_Right = styled.div`
    display: flex;
    align-items: center;
`;

export const PageHeader_SearchBar = styled(SearchBar)`
    background: ${gray1} !important;
    border: 2px solid ${gray3};
    margin-right: 1em;

    ${InputBar_Input} {
        background: ${gray1};
        font-family: ${font.light};
        margin-right: 1em;
    }
`;
